import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityState } from '../../../entity/entity.reducer';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { CarbonPartCommission } from '../models/part-commission';
import { getCarbonPartCommissionListState } from '../part-commission.reducer';

const createState = (id: IdType) => createSelector(
  getCarbonPartCommissionListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createCarbonPartCommissionListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.carbonPartCommission
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.carbonPartCommission]], entities) as CarbonPartCommission[]
);

export const createCarbonPartCommissionListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createCarbonPartCommissionListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createCarbonPartCommissionListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createCarbonPartCommissionListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createCarbonPartCommissionListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
